import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import BoxSections from './BoxSections'
import ContentDiv from './ContentDiv'
import HeroSections from './HeroSections'
import KeyFeature from './KeyFeature'
import { Helmet } from 'react-helmet'
import IndustriesServe from './industries-serve'
import WhyChooseInfograins from './why-choose-infograins'
import TransformingBusinesses from './transforming_businesses'
export default function AIPageIndex(props) {
    const { nft_slug } = useParams()
    // =========================== scroll To Top default =========================
    useEffect(() => {
        props.demo('top')
    }, [nft_slug])
    // =========================== scroll To Top default =========================
    return (
        <>
            <Helmet>
                <title>Reliable AI ML Development Services</title>
                <meta name="description" content="Infograins is the global leading AI ML Development Company that offers highly advanced artificial intelligence and machine learning development services." />
            </Helmet>
            <HeroSections />
            <BoxSections />
            <WhyChooseInfograins/>
            <IndustriesServe/>
            <TransformingBusinesses/>
            {/* <ContentDiv /> */}
        </>
    )
}
